import HTTP_METHODS from "src/general/constants/http/httpMethods";
import {
	LevelsGetRequest as Req,
	LevelsGetResponse as Res,
} from "src/business.InterfaceLayer/store/entities/loyaltyProgram.entity/redux/api/types/GET";
import { createBaseQueryDefinition } from "src/business.InterfaceLayer/store/services/utils.service/ResponseTransforms";
import { ApiQueryBuilder } from "src/business.InterfaceLayer/store/types/ApiQueryBuilder.type";
import { LoyaltyProgramFromDtoGet as Dto } from "src/business.InterfaceLayer/store/entities/loyaltyProgram.entity/services/dto/from.dto";
import { Nullable } from "../../../../../types/Nullable.type";
import LEVELS_PATHS from "../../paths";
import MAIN_PATHS from "../../../../../mainPaths";

const getRequestBaseDefinition = createBaseQueryDefinition(
	HTTP_METHODS.GET,
	MAIN_PATHS.LOYALTY_PROGRAM
);

const levelsApiGetQueries = (build: ApiQueryBuilder) => ({
	getMyLevel: build.query<Nullable<Res.MyLevelGet>, Req.MyLevelGet>({
		query: () => ({
			...getRequestBaseDefinition({
				path: LEVELS_PATHS.MY_LEVEL,
			}),
		}),
		transformResponse: Dto.getMLevels,
	}),
	getMyReferralSystem: build.query<
		Nullable<Res.MyReferralSystemGet>,
		Req.MyReferralSystemGet
	>({
		query: () => ({
			...getRequestBaseDefinition({
				path: LEVELS_PATHS.MY_REFERRAL_SYSTEM,
			}),
		}),
		transformResponse: Dto.getMyReferralSystem,
	}),
	getMyTransactions: build.query<
		Nullable<Res.MyTransactionsGet>,
		Req.MyTransactionsGet
	>({
		query: (params) => ({
			...getRequestBaseDefinition({
				path: LEVELS_PATHS.MY_TRANSACTIONS,
			}),
			params,
		}),
		transformResponse: Dto.getMyTransactions,
	}),
});

export default levelsApiGetQueries;
